module.exports = __webpack_public_path__ + "static/media/GothamRnd-Light.52ef94ed.otf";